module.exports = __webpack_public_path__ + "static/img/home_case_bg3_zh.aa8d47d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_case_bg3_zh.png
// module id = rgpb
// module chunks = 34